module.exports = __webpack_public_path__ + "static/plan-3867458992707cf0dcaca189b49f07fd.pdf";